import { RouteProp, useRoute } from "@react-navigation/native";
import { ClubNavigatorParamList } from "../../../navigators/ClubNavigator";
import { useApiQuery } from "../../../../lib/api";
import { Partner, PartnerDetail } from "./Partner";
import { Loader } from "../../../components/design-system/Loader";
import { Text } from "tamagui";

export const PartnerQueryRenderer = () => {
  const route = useRoute<RouteProp<ClubNavigatorParamList, "Partner">>();
  const partnerId = route.params.partnerId;

  const { data, isLoading, error } = useApiQuery<{ partner: PartnerDetail }>(
    ["partner", partnerId],
    `/api/v1/partners/${partnerId}`
  );

  if (isLoading) {
    return <Loader />;
  }

  if (error || !data?.partner) {
    return (
      <Text color="$red10" textAlign="center" py="$4" px="$4">
        Failed to load partner.
      </Text>
    );
  }

  return <Partner partner={data.partner} />;
};
